import { bool, func, string } from 'prop-types'
import { kuiperClassNames, Button } from '@opallabs/kuiper'

import './styles.scss'

const Buttons = ({
  className,
  isNewAsset,
  isLoading,
  onClose,
  onClickSave,
}) => (
  <div className={kuiperClassNames(className)}>
    <Button label="Cancel" onClick={onClose} type="nobutton" />
    <Button
      disabled={!isNewAsset}
      label="Save"
      isLoading={isLoading}
      theme="n8"
      onClick={onClickSave}
      type="primary"
    />
  </div>
)

Buttons.propTypes = {
  className: string,
  isLoading: bool,
  isNewAsset: bool,
  onClickSave: func,
  onClose: func,
}

export default Buttons
